import React from "react"; // eslint-disable-line no-unused-vars
import { Nav, NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import { addNotification as notify } from "reapop";
import connect from "react-redux/es/connect/connect";
import {AdminNavigationPaths} from "./adminNavigationPaths";

class AdminNavigation extends React.Component {
  constructor(props) {
    super(props);

    const currUrl = window.location.pathname;
    let openIndex = null;

    this.props.navigation.forEach((item, index) => {
      if (item.child_items.some((child) => child.child_url === currUrl)) {
        openIndex = index; 
      }
    });

    this.state = {
      openIndex, 
    };
  }

  toggleDropdown(index) {
    this.setState((prevState) => ({
      openIndex: prevState.openIndex === index ? null : index, 
    }));
  }

  render() {
    return (
      <div className={`${this.props.className} admin-navigation`}>
        {this.props.navigation.map(({ url, title, child_items }, i) => {
          const isOpen = this.state.openIndex === i;
          return child_items.length > 0 ? (
            <div key={i}>
              <div
                className="v2_child_dropdown_header"
                onClick={() => this.toggleDropdown(i)}
              >
                <span>{title}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className={`bi bi-chevron-down toggle-btn ${isOpen ? "open" : ""}`}
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              {isOpen && (
                <div>
                  {child_items.map(({ child_url, child_title }, index) => (
                    <Nav vertical pills key={index}>
                      <NavItem>
                        <NavLink exact className="nav-link" to={child_url}>
                          {child_title}
                        </NavLink>
                      </NavItem>
                    </Nav>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <Nav vertical pills key={i}>
              <NavItem>
                <NavLink exact className="nav-link" to={url}>
                  {title}
                </NavLink>
              </NavItem>
            </Nav>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps() {
  return {
    navigation: AdminNavigationPaths,
  };
}

export default connect(mapStateToProps, { notify })(AdminNavigation);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AdminNavigation.js